import React, { FC, useEffect, useRef, useState } from "react";
import classNames from "../../utils/twClassNames";
type Props = { children: React.ReactNode };

const CardGrid: FC<Props> = ({ children }) => {
  const targetRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(0);
  useEffect(() => {
    function handleResize() {
      if (targetRef && targetRef.current) {
        setWidth(targetRef.current.offsetWidth);
      }
    }

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function getGridCols(): string {
    if (width < 560) {
      return "grid-cols-2";
    } else if (width < 820) {
      return "grid-cols-3";
    } else if (width < 1050) {
      return "grid-cols-4";
    }
    return "grid-cols-4";
  }

  return (
    <div
      ref={targetRef}
      className={classNames("CardGrid pt-2 mb-6 grid gap-5", getGridCols())}
    >
      {children}
    </div>
  );
};

export default CardGrid;
